import { useState } from 'react';

import { Project } from '@/app/network/models/project';
import { Button } from '@/common/components/button';
import {
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
  DrawerTitle
} from '@/common/components/drawer';
import { CreateUpdateProjectForm } from '@/projects/components/create-update-project-form';
import { useCreateUpdateProjectForm } from '@/projects/hooks/use-create-update-project-form';
import { useUpdateProject } from '@/projects/queries';
import { mapProjectBillingTypeToCode } from '@/shared/projects';

export function UpdateProject({ project }: { project: Project }) {
  const [isOpen, setIsOpen] = useState(false);
  const updateProjectMutation = useUpdateProject();

  const form = useCreateUpdateProjectForm({
    defaultValues: {
      client: project.client ? { id: project.client.id, name: project.client.name } : null,
      name: project.name ?? '',
      budget: project.budget?.toString() ?? '',
      startOn: project.startOn ?? '',
      endOn: project.endOn ?? '',
      rate: project.rate?.toString() ?? '',
      billingType: mapProjectBillingTypeToCode(project.billingType)
    },
    onSubmit: async (values) => {
      const payload = {
        id: project.id,
        clientId: values.client?.id,
        name: values.name,
        budget: values.budget ? parseFloat(values.budget) : undefined,
        startOn: values.startOn || undefined,
        endOn: values.endOn || undefined,
        rate: parseFloat(values.rate),
        billingType: values.billingType
      };

      await updateProjectMutation.mutateAsync(
        { data: payload },
        {
          onSuccess: () => {
            handleClose();
          }
        }
      );
    }
  });

  const handleClose = () => {
    form.reset();
    setIsOpen(false);
  };

  function open() {
    setIsOpen(true);
  }

  return (
    <>
      <Button onClick={open}>Edit</Button>
      <Drawer open={isOpen} onClose={handleClose}>
        <DrawerContent>
          <DrawerHeader>
            <DrawerTitle>Edit Project</DrawerTitle>
          </DrawerHeader>
          <DrawerBody>
            <CreateUpdateProjectForm form={form} formId="update-project-form" />
          </DrawerBody>
          <DrawerFooter className="gap-3">
            <form.AppForm>
              <form.FormButton outline onClick={handleClose}>Cancel</form.FormButton>
              <form.FormButton type="submit" form="update-project-form">Update Project</form.FormButton>
            </form.AppForm>
          </DrawerFooter>
        </DrawerContent>
      </Drawer>
    </>
  );
}
